"use strict";
/**
 * Centralized webflow path mappings for redirects
 * This file contains all the mappings between Gatsby paths and Webflow paths
 * Redirects are controlled by a simple boolean flag instead of environment variables
 * to avoid timing issues and make the system more reliable.
 */
exports.__esModule = true;
exports.getFinalUrl = exports.getWebflowPath = exports.shouldRedirectToWebflow = exports.WEBFLOW_REDIRECTS_ENABLED = exports.WEBFLOW_PATH_MAPPINGS_RECORD = exports.WEBFLOW_PATH_MAPPINGS = void 0;
exports.WEBFLOW_PATH_MAPPINGS = [
    // Product pages
    {
        gatsbyPath: '/proposal-software',
        webflowPath: '/product/proposal-software',
        category: 'product'
    },
    {
        gatsbyPath: '/online-payment-software',
        webflowPath: '/product/online-payment-software',
        category: 'product'
    },
    {
        gatsbyPath: '/meeting-scheduler',
        webflowPath: '/product/meeting-scheduler',
        category: 'product'
    },
    {
        gatsbyPath: '/payment-reminders',
        webflowPath: '/product/payment-reminders',
        category: 'product'
    },
    {
        gatsbyPath: '/features',
        webflowPath: '/product/features',
        category: 'product'
    },
    {
        gatsbyPath: '/free-account-migration',
        webflowPath: '/product/free-account-migration',
        category: 'product'
    },
    {
        gatsbyPath: '/client-portal-software',
        webflowPath: '/product/client-portal-software',
        category: 'product'
    },
    {
        gatsbyPath: '/lp/finance',
        webflowPath: '/product/finance',
        category: 'product'
    },
    {
        gatsbyPath: '/lp/ai-start',
        webflowPath: '/product/ai',
        category: 'product'
    },
    // Company pages
    {
        gatsbyPath: '/contact-us',
        webflowPath: '/company/contact-us',
        category: 'company'
    },
    {
        gatsbyPath: '/careers',
        webflowPath: '/company/careers',
        category: 'company'
    },
    {
        gatsbyPath: '/about',
        webflowPath: '/company/about',
        category: 'company'
    },
    {
        gatsbyPath: '/press',
        webflowPath: '/company/press',
        category: 'company'
    },
    {
        gatsbyPath: '/lp/responsible-ai',
        webflowPath: '/company/responsible-ai',
        category: 'company'
    },
    // Legal pages
    {
        gatsbyPath: '/terms/terms-of-service',
        webflowPath: '/legal/terms-of-service',
        category: 'legal'
    },
    {
        gatsbyPath: '/terms/privacy',
        webflowPath: '/legal/privacy',
        category: 'legal'
    },
    {
        gatsbyPath: '/lp/policy/subpoena-policy',
        webflowPath: '/legal/subpoena-policy',
        category: 'legal'
    },
    // Partnership pages
    {
        gatsbyPath: '/referrals',
        webflowPath: '/partnerships/referrals',
        category: 'partnership'
    },
    // Industry pages
    {
        gatsbyPath: '/industry-caterers',
        webflowPath: '/lp/industry-caterers',
        category: 'lp'
    },
    {
        gatsbyPath: '/industry-photographers',
        webflowPath: '/lp/industry-photographers',
        category: 'lp'
    },
    {
        gatsbyPath: '/industry-designers',
        webflowPath: '/lp/industry-designers',
        category: 'lp'
    },
    {
        gatsbyPath: '/industry-florists',
        webflowPath: '/lp/industry-florists',
        category: 'lp'
    },
    {
        gatsbyPath: '/industry-consultants',
        webflowPath: '/lp/industry-consultants',
        category: 'lp'
    },
    {
        gatsbyPath: '/industry-marketing',
        webflowPath: '/lp/industry-marketing',
        category: 'lp'
    },
    {
        gatsbyPath: '/industry-interior-design',
        webflowPath: '/lp/industry-interior-design',
        category: 'lp'
    },
    {
        gatsbyPath: '/industry-social-media',
        webflowPath: '/lp/industry-social-media',
        category: 'lp'
    },
    {
        gatsbyPath: '/industry-wedding-planners',
        webflowPath: '/lp/industry-wedding-planners',
        category: 'lp'
    },
    {
        gatsbyPath: '/industry-freelancers',
        webflowPath: '/lp/industry-freelancers',
        category: 'lp'
    },
    // Business type pages
    {
        gatsbyPath: '/venue-management-software',
        webflowPath: '/business-type/venues',
        category: 'business-type'
    },
    // Get Started pages
    {
        gatsbyPath: '/get-started-free-crm',
        webflowPath: '/lp/get-started-free-crm',
        category: 'lp'
    },
    {
        gatsbyPath: '/get-started-easy-crm',
        webflowPath: '/lp/get-started-easy-crm',
        category: 'lp'
    },
    {
        gatsbyPath: '/get-started-crm',
        webflowPath: '/lp/get-started-crm',
        category: 'lp'
    },
    {
        gatsbyPath: '/get',
        webflowPath: '/lp/get',
        category: 'lp'
    },
    {
        gatsbyPath: '/get-invoice-templates',
        webflowPath: '/lp/get-invoice-templates',
        category: 'lp'
    }
];
/**
 * Convert the array of mappings to a Record for easy lookup
 */
exports.WEBFLOW_PATH_MAPPINGS_RECORD = exports.WEBFLOW_PATH_MAPPINGS.reduce(function (acc, mapping) {
    acc[mapping.gatsbyPath] = mapping.webflowPath;
    return acc;
}, {});
/**
 * Simple on/off switch for webflow redirects
 *
 * TO ENABLE WEBFLOW REDIRECTS: Change this to true
 * TO DISABLE WEBFLOW REDIRECTS: Change this to false
 *
 * This is the ONLY place you need to change to toggle the entire redirect system!
 */
exports.WEBFLOW_REDIRECTS_ENABLED = true;
/**
 * Check if a path should redirect to webflow
 */
var shouldRedirectToWebflow = function (path) {
    if (!exports.WEBFLOW_REDIRECTS_ENABLED)
        return false;
    return path in exports.WEBFLOW_PATH_MAPPINGS_RECORD;
};
exports.shouldRedirectToWebflow = shouldRedirectToWebflow;
/**
 * Get the webflow path for a given gatsby path
 */
var getWebflowPath = function (gatsbyPath) {
    if (!exports.WEBFLOW_REDIRECTS_ENABLED)
        return null;
    return exports.WEBFLOW_PATH_MAPPINGS_RECORD[gatsbyPath] || null;
};
exports.getWebflowPath = getWebflowPath;
/**
 * Get the final URL for a path (Gatsby or Webflow based on flag)
 */
var isFullUrl = function (path) {
    return path.startsWith('https://') || path.startsWith('http://');
};
var getFinalUrl = function (gatsbyPath, baseUrl) {
    if (baseUrl === void 0) { baseUrl = 'https://www.honeybook.com'; }
    if (isFullUrl(gatsbyPath)) {
        return gatsbyPath;
    }
    var cleanPath = gatsbyPath.replace(/^\/+/, '');
    if ((0, exports.shouldRedirectToWebflow)(gatsbyPath)) {
        var webflowPath = (0, exports.getWebflowPath)(gatsbyPath);
        if (webflowPath) {
            return "".concat(baseUrl).concat(webflowPath);
        }
    }
    var finalPath = cleanPath ? "/".concat(cleanPath) : '';
    return "".concat(baseUrl).concat(finalPath);
};
exports.getFinalUrl = getFinalUrl;
